/**
 * Sueco gift options core.
 *
 * 商品ページ・カートページ・マルチシップで共有する
 * 選択肢テーブルと正規プロパティキーの単一情報源。
 *
 * 正規キーの契約は sueco-all-app/docs/gift-info-canonical-keys.md に従う。
 * ここを変えるときは必ずあちらも更新すること。
 */
(function () {
  "use strict";

  if (window.SuecoGiftCore) return;

  var KEYS = {
    noshi: "のし",
    omotegaki: "表書き",
    naire: "名入れ",
    placement: "のし配置",
    bag: "手提げ袋",
    card: "カード",
    noshiVariantId: "_noshi_variant_id",
    cardVariantId: "_card_variant_id",
    bagVariantId: "_bag_variant_id",
    accessoryIds: "_gift_accessory_variant_ids",
    flag: "_gift_options",
    removedFlag: "_gift_options_removed",
    accessoryFlag: "_gift_accessory"
  };

  // 保存時に一度全部消してから組み立て直すキー群。
  var ALL_GIFT_KEYS = [
    KEYS.noshi,
    KEYS.omotegaki,
    KEYS.naire,
    KEYS.placement,
    KEYS.bag,
    KEYS.card,
    KEYS.noshiVariantId,
    KEYS.cardVariantId,
    KEYS.bagVariantId,
    KEYS.accessoryIds,
    KEYS.flag,
    KEYS.removedFlag
  ];

  var DEFAULT_PLACEMENT = "外のし";

  var OMOTEGAKI_OPTIONS = {
    蝶結び: [
      { value: "御祝", desc: "お祝い全般" },
      { value: "内祝", desc: "お返し全般" },
      { value: "御礼", desc: "お礼・感謝" },
      { value: "お中元", desc: "夏のご挨拶" },
      { value: "お歳暮", desc: "冬のご挨拶" },
      { value: "お年賀", desc: "年始のご挨拶" },
      { value: "御挨拶", desc: "ご挨拶全般" },
      { value: "出産祝", desc: "ご出産のお祝い" },
      { value: "出産内祝", desc: "出産祝いのお返し" },
      { value: "入学祝", desc: "入学のお祝い" },
      { value: "卒業祝", desc: "卒業のお祝い" },
      { value: "新築祝", desc: "新築・引越しのお祝い" }
    ],
    結び切り: [
      { value: "寿", desc: "結婚祝い" },
      { value: "結婚内祝", desc: "結婚祝いのお返し" },
      { value: "快気祝", desc: "病気回復のお祝い" },
      { value: "快気内祝", desc: "お見舞いのお返し" },
      { value: "御見舞御礼", desc: "お見舞いへのお礼" }
    ],
    "掛け紙（法事用など）": [
      { value: "志", desc: "香典返し・法事のお返し" },
      { value: "御仏前", desc: "法事のお供え" },
      { value: "御霊前", desc: "通夜・葬儀のお供え" },
      { value: "御供", desc: "お供え物" },
      { value: "粗供養", desc: "法事の引き出物" }
    ]
  };

  function omotegakiFor(noshiType) {
    return OMOTEGAKI_OPTIONS[noshiType] || [];
  }

  // テーマが埋め込んだギフト商品カタログ（Liquid 由来）。
  function catalog() {
    var el = document.getElementById("SuecoGiftCatalog");
    if (!el) return { enabled: false, productId: null, items: [] };
    try {
      var parsed = JSON.parse(el.textContent || "{}");
      parsed.items = parsed.items || [];
      return parsed;
    } catch (err) {
      console.error("[gift-core] catalog parse failed:", err);
      return { enabled: false, productId: null, items: [] };
    }
  }

  function itemsOfKind(kind) {
    return catalog().items.filter(function (item) {
      return item.kind === kind;
    });
  }

  function normalizeId(value) {
    var text = String(value == null ? "" : value)
      .replace("gid://shopify/ProductVariant/", "")
      .trim();
    return /^[0-9]+$/.test(text) ? text : "";
  }

  function findItem(variantId) {
    var id = normalizeId(variantId);
    if (!id) return null;
    var found = catalog().items.filter(function (item) {
      return String(item.id) === id;
    });
    return found.length ? found[0] : null;
  }

  function normalizeIds(values) {
    var seen = {};
    return (values || []).map(normalizeId).filter(function (id) {
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  // _gift_accessory_variant_ids は JSON 配列 / カンマ区切りの両方を受ける。
  function parseAccessoryIds(value) {
    if (!value) return [];
    if (Array.isArray(value)) return normalizeIds(value);
    var text = String(value).trim();
    if (!text) return [];
    try {
      var parsed = JSON.parse(text);
      if (Array.isArray(parsed)) return normalizeIds(parsed);
    } catch (err) {
      // カンマ区切りにフォールバック
    }
    return normalizeIds(text.split(","));
  }

  // line item properties から編集用の状態を復元する。
  // 旧キー（紙袋）で保存された既存カートも読めるようにしている。
  function stateFromProperties(properties) {
    var props = properties || {};
    var legacyBag = props["紙袋"] || "";
    return {
      noshiType: props[KEYS.noshi] || "",
      noshiVariantId: normalizeId(props[KEYS.noshiVariantId]),
      omotegaki: props[KEYS.omotegaki] || "",
      naire: props[KEYS.naire] || "",
      placement: props[KEYS.placement] || DEFAULT_PLACEMENT,
      bag: !!(props[KEYS.bag] || legacyBag),
      bagVariantId: normalizeId(props[KEYS.bagVariantId]),
      cardLabel: props[KEYS.card] || "",
      cardVariantId: normalizeId(props[KEYS.cardVariantId])
    };
  }

  // 紙袋は 2026-08-04 に廃止。bag variant が存在しない限りトグルは描画されず、
  // ここも空を返す。既存カート・過去注文の 手提げ袋 プロパティを読むためだけに
  // bag 系のコードを残している（発送側 ShippingManager が参照するキー）。
  function defaultBagVariantId() {
    var bags = itemsOfKind("bag");
    return bags.length ? normalizeId(bags[0].id) : "";
  }

  // 状態から付属品 variant ID 群を求める。順序は のし→シール→紙袋。
  function accessoryIdsFromState(state) {
    var ids = [];
    if (state.noshiType && state.noshiVariantId) ids.push(state.noshiVariantId);
    if (state.cardLabel && state.cardVariantId) ids.push(state.cardVariantId);
    if (state.bag) {
      var bagId = state.bagVariantId || defaultBagVariantId();
      if (bagId) ids.push(bagId);
    }
    return normalizeIds(ids);
  }

  // 既存 properties に状態を上書きした「全量」を返す。
  // /cart/change.js は properties を全置換するので、呼び出し側は
  // 必ずこの戻り値をそのまま送ること。
  function propertiesFromState(state, existingProperties) {
    var next = {};
    var existing = existingProperties || {};

    Object.keys(existing).forEach(function (key) {
      var value = existing[key];
      if (value === "" || value == null) return;
      if (ALL_GIFT_KEYS.indexOf(key) !== -1) return;
      if (key === "紙袋") return;
      next[key] = value;
    });

    var ids = accessoryIdsFromState(state);

    if (state.noshiType && state.noshiVariantId) {
      next[KEYS.noshi] = state.noshiType;
      next[KEYS.noshiVariantId] = state.noshiVariantId;
      if (state.omotegaki) next[KEYS.omotegaki] = state.omotegaki;
      if (state.naire) next[KEYS.naire] = state.naire;
      next[KEYS.placement] = state.placement || DEFAULT_PLACEMENT;
    }

    if (state.cardLabel && state.cardVariantId) {
      next[KEYS.card] = state.cardLabel;
      next[KEYS.cardVariantId] = state.cardVariantId;
    }

    if (state.bag) {
      var bagId = state.bagVariantId || defaultBagVariantId();
      next[KEYS.bag] = "あり";
      if (bagId) next[KEYS.bagVariantId] = bagId;
    }

    if (ids.length > 0) {
      next[KEYS.accessoryIds] = JSON.stringify(ids);
      next[KEYS.flag] = "true";
    } else if (Object.keys(next).length === 0) {
      // 全プロパティが空だと Shopify が行をマージしてしまうため印を残す
      next[KEYS.removedFlag] = "true";
    }

    return next;
  }

  // カート属性（＝注文タグ・のしPDFの入力）を組み立てる。
  function attributesFromState(state, quantitySuffix) {
    var suffix = quantitySuffix || "";
    var parts = [];

    if (state.noshiType) {
      var noshi = "のし: " + state.noshiType;
      if (state.omotegaki) noshi += " / 表書き: " + state.omotegaki;
      if (state.naire) noshi += " / 名入れ: " + state.naire;
      parts.push([noshi, suffix].filter(Boolean).join(" "));
    }
    if (state.bag) {
      parts.push(["手提げ袋: あり", suffix].filter(Boolean).join(" "));
    }
    if (state.cardLabel) parts.push("シール: " + state.cardLabel);

    return {
      ギフトオプション: parts.join(" / "),
      熨斗: state.noshiType ? "有" : "",
      熨斗の種類: state.noshiType || "",
      表書: state.omotegaki || "",
      名前: state.naire || "",
      手提げ袋: state.bag ? "あり" : "",
      カード: state.cardLabel || ""
    };
  }

  function formatPriceJPY(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return "";
    return "¥" + (n / 100).toLocaleString("ja-JP");
  }

  function summarize(state) {
    var ids = accessoryIdsFromState(state);
    if (ids.length === 0) return { count: 0, priceCents: 0, text: "未選択" };

    var total = 0;
    ids.forEach(function (id) {
      var item = findItem(id);
      if (item) total += parseInt(item.price, 10) || 0;
    });

    return {
      count: ids.length,
      priceCents: total,
      text: ids.length + "件選択中 +" + formatPriceJPY(total)
    };
  }

  // 入力の妥当性。商品ページ・カートで同じ文言を出すためここに集約する。
  function validate(state) {
    if (state.noshiWanted && !state.noshiVariantId) {
      return "のしの種類を選択してください。";
    }
    if (state.noshiVariantId && !state.omotegaki) {
      return "のしの表書きを選択してください。";
    }
    if (state.cardWanted && !state.cardVariantId) {
      return "シールの種類を選択してください。";
    }
    return null;
  }

  window.SuecoGiftCore = {
    KEYS: KEYS,
    ALL_GIFT_KEYS: ALL_GIFT_KEYS,
    DEFAULT_PLACEMENT: DEFAULT_PLACEMENT,
    OMOTEGAKI_OPTIONS: OMOTEGAKI_OPTIONS,
    omotegakiFor: omotegakiFor,
    catalog: catalog,
    itemsOfKind: itemsOfKind,
    findItem: findItem,
    normalizeId: normalizeId,
    normalizeIds: normalizeIds,
    parseAccessoryIds: parseAccessoryIds,
    stateFromProperties: stateFromProperties,
    accessoryIdsFromState: accessoryIdsFromState,
    defaultBagVariantId: defaultBagVariantId,
    propertiesFromState: propertiesFromState,
    attributesFromState: attributesFromState,
    summarize: summarize,
    formatPriceJPY: formatPriceJPY,
    validate: validate
  };
})();